import { render, staticRenderFns } from "./FormTemplate.vue?vue&type=template&id=baec51d2&scoped=true&"
import script from "./FormTemplate.vue?vue&type=script&lang=js&"
export * from "./FormTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplate.vue?vue&type=style&index=0&id=baec51d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baec51d2",
  null
  
)

export default component.exports